import { instance } from "libs/api";

import { Admin } from "../../common.types";
import { ApiRoutesProfile } from "./../../constants";

export const requestProfile = async (): Promise<Admin> => {
  return await instance.get(ApiRoutesProfile.Me);
};
